import StoreList from './StoreList'
export default StoreList
